// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate('/'); return; }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id });
        setUser(data.user);
        // Apply pending referral if any
        try {
          const ref = localStorage.getItem('pending_ref');
          if (ref) {
            await api.post('/referrals/apply', { code: ref }).catch(() => {});
            localStorage.removeItem('pending_ref');
          }
        } catch {}
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error(err);
        navigate('/', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-900 text-stone-100">
      <div className="text-center">
        <div className="font-display text-4xl mb-2">Connexion en cours...</div>
        <div className="text-stone-400">Un instant, on accorde les cordes.</div>
      </div>
    </div>
  );
}
